import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'cmv-permissions-denied',
	templateUrl: './permissions-denied.component.html',
	styleUrls: ['./permissions-denied.component.scss'],
})
export class PermissionsDeniedComponent {
	@Input() permissionsRequired: string;

	constructor() {}
}
